"use strict";
/*
 * @license
 * Copyright (c) 2019 Cristian Abrante. All rights reserved.
 * Licensed under the MIT License. See LICENSE in the project root for license information.
 */

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaseReplacement_1 = require("./BaseReplacement");

var AgeBased =
/** @class */
function (_super) {
  __extends(AgeBased, _super);

  function AgeBased() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  AgeBased.prototype.sortMethod = function (a, b) {
    return a.age - b.age;
  };

  return AgeBased;
}(BaseReplacement_1.default);

exports.default = AgeBased;